import { render, staticRenderFns } from "./sttSsignWeblist.vue?vue&type=template&id=2081a834&scoped=true"
import script from "./sttSsignWeblist.vue?vue&type=script&lang=js"
export * from "./sttSsignWeblist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2081a834",
  null
  
)

export default component.exports